import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, map, Observable } from 'rxjs';
import { PlanwertService } from '../../service/planwert/planwert.service';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';
import { PlanwertDetail } from '../../domain/model/planwert-detail.model';
import { PlanwertStatus } from '../../domain/model/planwert-status.enum';
import { Erzeugungsanlage } from '../../domain/model/erzeugungsanlage';
import { ErzeugungsanlageService } from '../../service/erzeugungsanlage/erzeugungsanlage.service';

@Component({
    selector: 'redispatch-planwert-detail',
    templateUrl: './planwert-detail.component.html',
    styleUrls: [
        './planwert-detail.component.scss',
    ],
    standalone: false,
})
export class PlanwertDetailComponent {

    public data$: Observable<{
        readonly: boolean,
        erzeugungsanlage: Erzeugungsanlage | null,
        planwert: PlanwertDetail | null,
        alreadyAllocatedDatesForDokumentId: Date[]
    }>;
    public dokumentenId: string;
    public stwId: string;


    private activeRoute = inject(ActivatedRoute);
    private authService = inject(AuthenticationService);
    private planwertService = inject(PlanwertService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);
    private erzeugungsanlageService = inject(ErzeugungsanlageService);

    constructor() {
        this.dokumentenId = this.activeRoute.snapshot.queryParams['erzeugungsanlage'];
        this.stwId = this.teilgebietSelectionService.getSelectedStadtwerkeId();
        this.data$ = combineLatest([
            this.authService.user$.pipe(map(u => !!u && u.netzbetreiberType === 'WESTNETZ')),
            this.erzeugungsanlageService.getErzeugungsanlage(this.dokumentenId),
            this.planwertService.getPlanwerte(this.dokumentenId, this.stwId),
            this.planwertService.listPlanwerte(null, {
                stadtwerkeId: this.stwId,
                erzeugungsanlageDokumentenId: this.dokumentenId,
                status: [
                    PlanwertStatus.OPEN,
                ],
            }).pipe(
                map(page => page.content.map(planwertListItem => planwertListItem.dataTransferDate)),
            ),
        ]).pipe(
            map(([
                readonly,
                erzeugungsanlage,
                planwert,
                otherOpenPlanwerteForDokumentenId,
            ]) => {
                return {
                    readonly,
                    erzeugungsanlage,
                    planwert,
                    alreadyAllocatedDatesForDokumentId: otherOpenPlanwerteForDokumentenId,
                };
            }),
        );
    }
}
